export const navigationSettings = [
    {
        title: 'Spotify',
        url: '/case-assignment/spotify',
        icon: 'search'
    },
    {
        title: 'Carousel',
        url: '/case-assignment/carousel',
        icon: 'image'
    },
    {
        title: 'Auto Complete',
        url: '/case-assignment/auto-complete',
        icon: 'align-justify'
    }
];



// WEBPACK FOOTER //
// ./src/app/layouts/navigation.settings.ts